import { Application } from "@hotwired/stimulus"

import HelloController from "./hello_controller"

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("hello", HelloController)
